import { render, staticRenderFns } from "./PunctualityIcon.vue?vue&type=template&id=43c2140b&scoped=true"
import script from "./PunctualityIcon.vue?vue&type=script&lang=js"
export * from "./PunctualityIcon.vue?vue&type=script&lang=js"
import style0 from "./PunctualityIcon.vue?vue&type=style&index=0&id=43c2140b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c2140b",
  null
  
)

export default component.exports